import { render, staticRenderFns } from "./GolfProtection.vue?vue&type=template&id=3157e0f2&scoped=true"
import script from "./GolfProtection.vue?vue&type=script&lang=js"
export * from "./GolfProtection.vue?vue&type=script&lang=js"
import style0 from "./GolfProtection.vue?vue&type=style&index=0&id=3157e0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157e0f2",
  null
  
)

export default component.exports